import React from "react";
import { Empty } from "antd";
import { useNavigate } from "react-router-dom";
import { active, inActive } from "../Dashboard/icons";
import Td from "../common/Td";

export default function AdminFleetList({ fleets }) {
  const navigate = useNavigate();
  return (
    <div className="mt-6">
      <table className="table">
        <thead className="border-b-2 border-base-300">
          <tr className="text-[#B1B1B1] text-[15px] font-[700] leading-[35px]">
            <th>Fleet name</th>
            <th>
              <div className="flex gap-2 items-center">
                <img src={active} alt="active" /> Online
              </div>
            </th>
            <th>
              <div className="flex gap-2 items-center">
                <img src={inActive} alt="inactive" /> Offline
              </div>
            </th>
            <th>Active</th>
            <th>Inactive</th>
            <th>Total</th>
          </tr>
        </thead>
        <tbody className="mt-3">
          {fleets?.length ? (
            <>
              {fleets.map(
                ({
                  id,
                  admin_id,
                  thing_group,
                  device_count,
                  online_count,
                  active_count,
                }) => {
                  return (
                    <tr
                      onClick={() =>
                        navigate(`/admins/${admin_id}/fleets/${id}/devices`)
                      }
                      key={id}
                      className="shadow-[0_3.5px_5.5px_0_#00000005] h-16 cursor-pointer"
                    >
                      <Td className={"rounded-l-[15px]"}>{thing_group}</Td>
                      <Td> {online_count}</Td>
                      <Td> {device_count - online_count}</Td>
                      <Td> {active_count}</Td>
                      <Td>{device_count - active_count}</Td>
                      <Td className={"rounded-r-[15px]"}> {device_count}</Td>
                    </tr>
                  );
                }
              )}
            </>
          ) : (
            <tr>
              <td colSpan="5" className="text-[20px] text-center">
                <Empty />
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
